import { Translator } from '@/types/translator.type';

export const GENERAL_BENEFITS_STEPS = (t: Translator) => [
  t('common.configuration'),
  t('common.pricingSummary'),
];
